import { action } from 'easy-peasy';
import { IActionResetAiSettings } from '../types';

const resetAiSystemSettings: IActionResetAiSettings = action(state => {
  state.currentSystem = null;
});

export default resetAiSystemSettings;
